import React from "react";
import { Link } from 'react-router-dom'
import SectionTitle from "../SectionTitle/SectionTitle";
import { Store, FlaskRoundIcon as Flask, Cpu } from 'lucide-react'

const ServiceSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const services = [
        {
            id: 1,
            icon: Store,
            title: 'Operations',
            description: 'Optimizing front-end retail operations and prescription services to enhance customer experience and increase revenue streams.',
            slug: 'operations'
        },
        {
            id: 2,
            icon: Flask,
            title: 'Specialization',
            description: 'Expanding into high-margin specialty pharmacy services to capture growing market opportunities in complex medication management.',
            slug: 'specialization'
        },
        {
            id: 3,
            icon: Cpu,
            title: 'Technology',
            description: 'Implementing cutting-edge pharmacy management systems and digital health solutions to improve efficiency and patient care.',
            slug: 'technology'
        },
    ];

    const { hclass, sliceStart = 0, sliceEnd = 3, showSectionTitle = true, AllServices = true } = props;

    return (
        <section className={hclass}>
            <div className="container">
                {showSectionTitle && (
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-12">
                            <SectionTitle title={"Investment Focus Areas"} subtitle={"Strategic Growth Initiatives"} />
                        </div>
                    </div>
                )}
                <div className="row">
                    {services.slice(sliceStart, sliceEnd).map((service, index) => (
                        <div className="col-lg-4 col-md-6 col-12" key={index}>
                            <div className="service_card">
                                <div className="icon">
                                    <service.icon style={{ marginTop: 15 }} size={70} />
                                </div>
                                <div className="content">
                                    <h2>{service.title}</h2>
                                    <p>{service.description}</p>
                                    {/* <Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>
                                        <i className="flaticon-right-arrow"></i>
                                    </Link> */}
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* {AllServices && (
                        <div className="col-12">
                            <div className="btn">
                                <Link onClick={ClickHandler} to={"/services"} className="theme-btn">See All Services</Link>
                            </div>
                        </div>
                    )} */}
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;

